var _this = this;
import { __makeTemplateObject } from "tslib";
import * as React from 'react';
import { border, color } from '@metro-ui/tokens';
import { css } from '@emotion/core';
export var getValueOf = function (_a) {
    var _b = _a.props, searchName = _b.searchName, value = _b.value, children = _b.children;
    return value || searchName || children;
};
export var getLabelOf = function (_a) {
    var _b = _a.props, searchName = _b.searchName, children = _b.children;
    return searchName || children;
};
export var findSuggestionByValue = function (children, value) {
    return React.Children.toArray(children).find(function (suggestion) {
        return (getValueOf(suggestion) === value);
    });
};
export var debounce = function (func, timeout) {
    var timer;
    return function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        clearTimeout(timer);
        timer = setTimeout(function () {
            func.apply(_this, args);
        }, timeout);
    };
};
var statusMap = {
    valid: color.palette.green.tint[40],
    focused: color.focused,
    info: color.focused,
    error: color.palette.red.tint[40],
};
export var statusStyle = function (status) {
    return css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    border: ", " solid ", ";\n    box-shadow: 0 0 0 ", " ", ";\n  "], ["\n    border: ", " solid ", ";\n    box-shadow: 0 0 0 ", " ", ";\n  "])), border.width.thin, statusMap[status], border.width.thin, statusMap[status]);
};
export var borderAnimation = css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  transition: 0.125s ease-in-out 0s;\n  transition-property: border-color;\n"], ["\n  transition: 0.125s ease-in-out 0s;\n  transition-property: border-color;\n"])));
var templateObject_1, templateObject_2;
//# sourceMappingURL=util.js.map